const Author = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="92"
      height="88"
      viewBox="0 0 92 88"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6813 51.2237C93.6134 61.4008 75.9852 75.5329 51.3089 82.7915C26.6317 90.0501 4.25077 87.6841 1.3187 77.508C-1.61337 67.3319 16.0138 53.1988 40.6911 45.9402C65.3684 38.6835 87.7493 41.0476 90.6813 51.2237Z"
        fill="#212121"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5611 86.9366C30.0633 87.3108 40.4626 85.9812 51.3089 82.7905C62.1552 79.6007 71.6367 75.0834 78.6113 70.1572L60.0992 5.90392C59.0642 2.31026 55.3047 0.223361 51.7459 1.27077L7.63574 14.2456C4.07792 15.293 2.01395 19.0906 3.04991 22.6852L21.5611 86.9366Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7212 23.9972L20.5722 32.8675L19.416 28.854L49.5661 19.9857L50.7212 23.9972ZM54.2334 36.1889L24.0843 45.0572L22.9281 41.0438L53.0782 32.1755L54.2334 36.1889ZM57.7465 48.3806L27.5964 57.2489L26.4403 53.2355L56.5904 44.3672L57.7465 48.3806Z"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.9792 22.9021C70.709 27.953 65.2997 36.4808 64.9004 48.2498C64.813 50.7624 64.97 53.4136 65.3673 56.1281L65.5361 57.2943L66.6783 56.8835L74.9005 53.9234C82.5227 50.6109 82.4005 43.2652 81.9952 40.2616L81.7877 38.7241L80.4617 39.6042C79.7892 40.0527 79.1645 40.3863 78.5348 40.6387L74.1873 42.2049C73.9986 42.2722 73.7831 42.1544 73.7046 41.9406C73.6251 41.7277 73.7145 41.499 73.9032 41.4317L78.2388 39.8715C86.9704 36.3649 83.2179 25.7909 83.0531 25.3424L81.9744 22.413L80.9792 22.9021Z"
        fill="#8646F2"
      />
      <path
        d="M67.289 65.4506C67.289 65.4506 54.9717 33.9689 82.1708 21.8911L83.3955 25.2184C83.3955 25.2184 87.5741 36.5657 78.3468 40.2692L74.0451 41.8176"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.968 38.251C81.968 38.251 85.357 49.827 74.9795 54.3314L70.6788 55.8788L65.2695 57.8241"
        stroke="#212121"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Author;
